import {SxProps} from '@mui/material';

export const styles: Record<string, SxProps> = {
  buttonContainer: {
    borderRadius: '0 !important',
  },
  button: {
    height: '62px',
    borderTopRightRadius: '16px !important',
    borderTopLeftRadius: '16px !important',
    borderBottomLeftRadius: '0px !important',
    borderBottomRightRadius: '0px !important',
    justifyContent: 'flex-start',
    textTransform: 'none',
    padding: '0',
    border: 'none !important',
    ':focus': {
      border: 'none !important',
    },
  },
};
